<template>
  <div class="py-4">
    <div class="space-y-2.5">
      <UiNativeSelect
        :model-value="internalValue"
        :items="takeOutField(block.materials, 'title')"
        value-key="sku"
        title-key="title"
        :name="block.slug"
        :label="`${title}:`"
        :label-class="`${labelClass} font-normal`"
        :placeholder="$t('selectOptionPlaceholder', { name: title })"
        :data-e2e-item-group="
          sizesSKUs.includes(block.sku)
            ? `size-filter-group-${block.view_type}`
            : `${block.sku}-filter-group-${block.view_type}`
        "
        show-data-e2e-item
        :size-data-e2e-item="block.sku === 'RING_SIZE'"
        :view-type="block.view_type"
        @update:modelValue="onUpdate"
      />
    </div>
    <slot name="additional" />
  </div>
</template>

<script setup lang="ts">
import {
  IProductMaterialFilterEvent,
  IProductMaterialFilterProps,
  MaterialData,
} from "ecom-types";
import { sizesSlugs, sizesSKUs } from "~/configs";

const props = defineProps<
  IProductMaterialFilterProps & {
    skipDisable?: boolean;
    disabledButClickable?: boolean;
  }
>();

const emit = defineEmits<{
  (e: "filter", value: IProductMaterialFilterEvent): void;
}>();

const route = useRoute();

const isDefaultSize = computed(() => {
  return route.query.size === "default";
});

const isSize = computed(() => {
  return sizesSlugs.includes(props.block.slug);
});

const internalValue = computed(() => {
  if (isSize.value) {
    return (!isDefaultSize.value && props.selectedItem?.sku) || "";
  } else {
    return props.selectedItem?.sku || "";
  }
});

function onUpdate(value: string) {
  const currentItem = props.block.materials.find(
    (material) => material.sku === value,
  );

  onFilterClick(props.block.slug, currentItem);
}

function takeOutField(
  items: Array<MaterialData & { disabled?: boolean }>,
  field: string,
) {
  return items.map((el) => ({
    ...el,
    [field]: el.currentTranslation?.[field],
    disabled: !props.skipDisable && el?.disabled && !props.disabledButClickable,
  }));
}

function onFilterClick(slug: string, item?: MaterialData) {
  emit("filter", { slug, item });
}
</script>
